// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608130342/js/" + chunkId + "." + {"44":"291e8302","225":"10ea663e","481":"f032fd78","486":"08c202f1","770":"379f10ae"}[chunkId] + ".0.40961645103280797.chunk.js";
};